
import axios from 'axios';
import { useAuthStore } from '../store';
import { envVariables } from '../helpers';
const baseURL = envVariables.REACT_APP_API_URL;


const granjaApi = axios.create({
    baseURL: baseURL
});


// Configurar Interceptores
granjaApi.interceptors.request.use( config => {
    const token = useAuthStore.getState().token;
    if ( token ) {
        config.headers = { ...config.headers, 'x-token': token }
    }
    return config;
})



export {
    granjaApi
}